import HomeIcon from "@mui/icons-material/Home";

export default function LogoIcon() {
  return <HomeIcon fontSize="large" color="primary" />;
}
